module.exports = __webpack_public_path__ + "static/media/17.af5ac989.mp3";